export default "__VITE_ASSET__bb7a76fc__"